module.exports = __webpack_public_path__ + "img/icon-facebook-gray.2100af4a.svg";